// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/site/membership/v4/membership.proto (package legebill.site.membership.v4, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../../../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legebill/site/membership/v4/membership.proto.
 */
export const file_legebill_site_membership_v4_membership: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_api_annotations]);

/**
 * @generated from message legebill.site.membership.v4.GetMembershipRequest
 */
export type GetMembershipRequest = Message<"legebill.site.membership.v4.GetMembershipRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * Required. Set to "me" to get membership for the current user.
   *
   * @generated from field: string user_id = 2;
   */
  userId: string;
};

/**
 * Describes the message legebill.site.membership.v4.GetMembershipRequest.
 * Use `create(GetMembershipRequestSchema)` to create a new message.
 */
export const GetMembershipRequestSchema: GenMessage<GetMembershipRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_membership_v4_membership, 0);

/**
 * @generated from message legebill.site.membership.v4.ListMembershipsRequest
 */
export type ListMembershipsRequest = Message<"legebill.site.membership.v4.ListMembershipsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message legebill.site.membership.v4.ListMembershipsRequest.
 * Use `create(ListMembershipsRequestSchema)` to create a new message.
 */
export const ListMembershipsRequestSchema: GenMessage<ListMembershipsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_membership_v4_membership, 1);

/**
 * @generated from message legebill.site.membership.v4.ListMembershipsResponse
 */
export type ListMembershipsResponse = Message<"legebill.site.membership.v4.ListMembershipsResponse"> & {
  /**
   * @generated from field: repeated legebill.site.membership.v4.Membership memberships = 1;
   */
  memberships: Membership[];
};

/**
 * Describes the message legebill.site.membership.v4.ListMembershipsResponse.
 * Use `create(ListMembershipsResponseSchema)` to create a new message.
 */
export const ListMembershipsResponseSchema: GenMessage<ListMembershipsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_membership_v4_membership, 2);

/**
 * @generated from message legebill.site.membership.v4.Membership
 */
export type Membership = Message<"legebill.site.membership.v4.Membership"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 5;
   */
  userId: string;

  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * @generated from field: string first_name = 6;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 7;
   */
  lastName: string;

  /**
   * use ListSitePermissions rpc when possible
   *
   * @generated from field: legebill.site.membership.v4.Authority authority = 3 [deprecated = true];
   * @deprecated
   */
  authority: Authority;

  /**
   * @generated from field: legebill.site.membership.v4.MembershipStatus status = 8;
   */
  status: MembershipStatus;

  /**
   * @generated from field: string email = 9;
   */
  email: string;

  /**
   * @generated from field: string external_id = 10;
   */
  externalId: string;
};

/**
 * Describes the message legebill.site.membership.v4.Membership.
 * Use `create(MembershipSchema)` to create a new message.
 */
export const MembershipSchema: GenMessage<Membership> = /*@__PURE__*/
  messageDesc(file_legebill_site_membership_v4_membership, 3);

/**
 * @generated from message legebill.site.membership.v4.ListSitePermissionsRequest
 */
export type ListSitePermissionsRequest = Message<"legebill.site.membership.v4.ListSitePermissionsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * Set if needed to check only some specific permissions.
   * Optional: If empty, all site permissions assigned to the user will be returned.
   *
   * @generated from field: repeated legebill.site.membership.v4.SitePermission permissions_to_check = 2;
   */
  permissionsToCheck: SitePermission[];
};

/**
 * Describes the message legebill.site.membership.v4.ListSitePermissionsRequest.
 * Use `create(ListSitePermissionsRequestSchema)` to create a new message.
 */
export const ListSitePermissionsRequestSchema: GenMessage<ListSitePermissionsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_membership_v4_membership, 4);

/**
 * @generated from message legebill.site.membership.v4.ListSitePermissionsResponse
 */
export type ListSitePermissionsResponse = Message<"legebill.site.membership.v4.ListSitePermissionsResponse"> & {
  /**
   * @generated from field: repeated legebill.site.membership.v4.SitePermission site_permissions = 1;
   */
  sitePermissions: SitePermission[];
};

/**
 * Describes the message legebill.site.membership.v4.ListSitePermissionsResponse.
 * Use `create(ListSitePermissionsResponseSchema)` to create a new message.
 */
export const ListSitePermissionsResponseSchema: GenMessage<ListSitePermissionsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_membership_v4_membership, 5);

/**
 * @generated from enum legebill.site.membership.v4.Authority
 */
export enum Authority {
  /**
   * @generated from enum value: AUTHORITY_UNSPECIFIED = 0;
   */
  AUTHORITY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * @generated from enum value: USER_ADMIN = 5;
   */
  USER_ADMIN = 5,

  /**
   * @generated from enum value: MANAGER = 2;
   */
  MANAGER = 2,

  /**
   * @generated from enum value: OWNER = 3;
   */
  OWNER = 3,
}

/**
 * Describes the enum legebill.site.membership.v4.Authority.
 */
export const AuthoritySchema: GenEnum<Authority> = /*@__PURE__*/
  enumDesc(file_legebill_site_membership_v4_membership, 0);

/**
 * @generated from enum legebill.site.membership.v4.MembershipStatus
 */
export enum MembershipStatus {
  /**
   * @generated from enum value: MEMBERSHIP_STATUS_UNSPECIFIED = 0;
   */
  MEMBERSHIP_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: INACTIVE = 2;
   */
  INACTIVE = 2,

  /**
   * @generated from enum value: ANONYMIZED = 3;
   */
  ANONYMIZED = 3,

  /**
   * @generated from enum value: ACCOUNT_DELETED = 4;
   */
  ACCOUNT_DELETED = 4,
}

/**
 * Describes the enum legebill.site.membership.v4.MembershipStatus.
 */
export const MembershipStatusSchema: GenEnum<MembershipStatus> = /*@__PURE__*/
  enumDesc(file_legebill_site_membership_v4_membership, 1);

/**
 * TODO: Add more permission types according to https://help.wisetime.com/hc/en-us/articles/13627871133975-WiseTime-Authority-Levels
 *
 * @generated from enum legebill.site.membership.v4.SitePermission
 */
export enum SitePermission {
  /**
   * @generated from enum value: SITE_PERMISSION_UNSPECIFIED = 0;
   */
  SITE_PERMISSION_UNSPECIFIED = 0,

  /**
   * @generated from enum value: POST_TIME = 1;
   */
  POST_TIME = 1,

  /**
   * @generated from enum value: POST_ASSOCIATED_TIME = 2 [deprecated = true];
   * @deprecated
   */
  POST_ASSOCIATED_TIME = 2,

  /**
   * View reports for all site members.
   * User can still view own report(s) if this permission is absent.
   *
   * @generated from enum value: VIEW_REPORTS = 3;
   */
  VIEW_REPORTS = 3,

  /**
   * @generated from enum value: VIEW_DASHBOARD = 5;
   */
  VIEW_DASHBOARD = 5,

  /**
   * Manage site membership details e.g. exp weighting percentage, external user id.
   *
   * @generated from enum value: EDIT_SITE_MEMBERSHIPS = 6;
   */
  EDIT_SITE_MEMBERSHIPS = 6,

  /**
   * Manage site, subscription, connection, tags, activity types.
   *
   * @generated from enum value: EDIT_SITE_SETTINGS = 7;
   */
  EDIT_SITE_SETTINGS = 7,

  /**
   * @generated from enum value: MANAGE_TAGS = 8;
   */
  MANAGE_TAGS = 8,

  /**
   * View own trends only.
   *
   * @generated from enum value: VIEW_TRENDS_OWN = 9;
   */
  VIEW_TRENDS_OWN = 9,

  /**
   * View trends for all site members.
   *
   * @generated from enum value: VIEW_TRENDS_OTHERS = 10;
   */
  VIEW_TRENDS_OTHERS = 10,

  /**
   * Manage post expectation for site
   *
   * @generated from enum value: MANAGE_POST_EXPECTATION = 11;
   */
  MANAGE_POST_EXPECTATION = 11,
}

/**
 * Describes the enum legebill.site.membership.v4.SitePermission.
 */
export const SitePermissionSchema: GenEnum<SitePermission> = /*@__PURE__*/
  enumDesc(file_legebill_site_membership_v4_membership, 2);

/**
 * Resources of the Membership service API include:
 *
 * - memberships/*
 *
 * All RPCs are executed in the context of a site, which is identified by name in the URL of
 * the request. For example, to operate on memberships for the site "spruson-lawyers", use
 * the base URL https://spruson-lawyers.legebill.com/.
 *
 * @generated from service legebill.site.membership.v4.MembershipService
 */
export const MembershipService: GenService<{
  /**
   * Get the current user's membership at this site.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:         If the requested user_id is not found in the DB
   *                      If no site for provided site_id is found in the DB (relevant to site permissions)
   *                      If no subscriber (linked to site) is found in the DB (relevant to site permissions)
   * - PERMISSION_DENIED: If the user that performed the request does not have the required permission for this site
   *                      is not a member of this site
   *
   * @generated from rpc legebill.site.membership.v4.MembershipService.GetMembership
   */
  getMembership: {
    methodKind: "unary";
    input: typeof GetMembershipRequestSchema;
    output: typeof MembershipSchema;
  },
  /**
   * Fetches all memberships at this site.
   *
   * Possible failures:
   * - INVALID_ARGUMENT:  Request is invalid (one or more required fields are missing or in an invalid format)
   * - NOT_FOUND:         If no site for provided site_id is found in the DB (relevant to site permissions)
   *                      If no subscriber (linked to site) is found in the DB (relevant to site permissions)
   * - PERMISSION_DENIED: If the user that performed the request does not have the required permission for this site
   *                      is not a member of this site
   *
   * @generated from rpc legebill.site.membership.v4.MembershipService.ListMemberships
   */
  listMemberships: {
    methodKind: "unary";
    input: typeof ListMembershipsRequestSchema;
    output: typeof ListMembershipsResponseSchema;
  },
  /**
   * Get site permissions for the current user.
   *
   * @generated from rpc legebill.site.membership.v4.MembershipService.ListSitePermissions
   */
  listSitePermissions: {
    methodKind: "unary";
    input: typeof ListSitePermissionsRequestSchema;
    output: typeof ListSitePermissionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_legebill_site_membership_v4_membership, 0);

